import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { Button as AntButton, Modal, Table, TableColumnsType } from 'antd';
import Pagination from '../../components/Pagination';
import Button from '../Button';
import Loader from '../Loader';
import Radio from '../Radio';
import config from '../../lib/config';
import { IEmployeeItem } from '../../models/employees.model';
import useAxios from '../../hooks/useAxios';
import { getEmployees } from '../../api/employees.api';
import ErrorResponse from '../ErrorResponse';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  campusCode: string|undefined;
  setTeacher: (teacher: any) => void;
}

const SelectTeacherModal: FC<IProps> = ({
  visible, setVisible, campusCode, setTeacher
}) => {
  const { t } = useTranslation();
  const { arr: res, isLoading, error, executeArr: execute } = useAxios<any>();

  // 검색용 키워드 (강사명)
  const [keyword, setKeyword] = useState('');
  // 선택한 강사 (radio)
  const [staff, setStaff] = useState<IEmployeeItem>();
  // 강사 목록
  const [data, setData] = useState<IEmployeeItem[]>([]);
  const [filteredData, setFilteredData] = useState<IEmployeeItem[]>([]);
  // 테이블 페이지
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (campusCode) {
      execute([
        getEmployees({ campusCode, authGroup: 'T' }),
        getEmployees({ campusCode, authGroup: 'O' }),
      ]);
    }
  }, [campusCode]);

  useEffect(() => {
    if (res.length && !isLoading) {
      const _data = [...res[0].data, ...res[1].data];
      setData(_data);
      setFilteredData(_data);
    }
  }, [res, isLoading]);

  const onSearch = () => {
    let newData = _.cloneDeep(data);

    if (keyword) {
      newData = newData.filter(item => item.memberName?.toLowerCase()?.includes(keyword?.toLowerCase()));
    }

    setFilteredData(newData);
  }

  const columns: TableColumnsType<IEmployeeItem> = [
    {
      title: t('class.class.column28'),
      dataIndex: 'memberName',
      key: 'memberName',
      sorter: (a, b) => a.memberName?.localeCompare(b.memberName),
      align: 'center'
    },
    {
      title: '',
      key: 'memberCode',
      dataIndex: 'memberCode',
      render: (value: string, record) => (
        <Radio
          className="mr-0"
          checked={value === staff?.memberCode}
          onChange={() => setStaff(record)}
          text=""
        />
      ),
      align: 'center'
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('class.class.title7')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                if (staff) setTeacher(staff);
                setVisible(false);
              }}
              aria-disabled={!staff}
              disabled={!staff}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          <div className="comm-bx__between">
            <div />
            <div className="comm-btn__area">
              <input
                type="text"
                className="form-control w-240p"
                placeholder={t('class.class.placeholder6')}
                value={keyword}
                onChange={(e => setKeyword(e.target.value))}
                onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
              />
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </div>
          <div className='comm-table__area mt-0'>
            <Table
              columns={columns}
              dataSource={filteredData || undefined}
              pagination={{
                current: page,
                pageSize: config.miniPageSize
              }}
            />
          </div>
          <div className="comm-bx__between"> 
            <div />
            <div className="common-paging center">
              <Pagination
                count={filteredData.length}
                page={page}
                setPage={setPage}
                mini
              />
            </div>
            <div />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SelectTeacherModal;
